'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * @param date {Date | number}
 * @param format {string} - from https://docs.angularjs.org/api/ng/filter/date
 'yyyy': 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
 'yy': 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
 'MMMM': Month in year (January-December)
 'MMM': Month in year (Jan-Dec)
 'MM': Month in year, padded (01-12)
 'M': Month in year (1-12)
 'dd': Day in month, padded (01-31)
 'd': Day in month (1-31)
 'HH': Hour in day, padded (00-23)
 'H': Hour in day (0-23)
 'hh': Hour in AM/PM, padded (01-12)
 'h': Hour in AM/PM, (1-12)
 'mm': Minute in hour, padded (00-59)
 'm': Minute in hour (0-59)
 'ss': Second in minute, padded (00-59)
 's': Second in minute (0-59)
 * @param utc {boolean}
 */
function formatDate(date, format, utc) {
    if (utc === void 0) { utc = false; }
    if (!date) {
        return "";
    }
    if (typeof date === 'number') {
        date = new Date(date);
    }
    var fullMonthNames = [
        "Ianuarie",
        "Februarie",
        "Martie",
        "Aprilie",
        "Mai",
        "Iunie",
        "Iulie",
        "August",
        "Septembrie",
        "Octombrie",
        "Noiembrie",
        "Decembrie",
    ];
    var shortMonthNames = [
        "Ian",
        "Feb",
        "Mar",
        "Apr",
        "Mai",
        "Iun",
        "Iul",
        "Aug",
        "Sep",
        "Oct",
        "Noi",
        "Dec",
    ];
    var leftPadDate = function (num) {
        return num < 10 ? "0" + num : num.toString();
    };
    var day = utc ? date.getUTCDate() : date.getDate();
    var month = utc ? date.getUTCMonth() : date.getMonth();
    var year = utc ? date.getUTCFullYear() : date.getFullYear();
    var hours = utc ? date.getUTCHours() : date.getHours();
    var minutes = utc ? date.getUTCMinutes() : date.getMinutes();
    var seconds = utc ? date.getUTCSeconds() : date.getSeconds();
    if (format) {
        var res = format;
        res = res.replace(/yyyy/g, year.toString());
        res = res.replace(/yy/g, (year % 100).toString());
        res = res.replace(/dd/g, leftPadDate(day));
        res = res.replace(/d/g, day.toString());
        res = res.replace(/HH/g, leftPadDate(hours));
        res = res.replace(/H/g, hours.toString());
        res = res.replace(/hh/g, leftPadDate(hours % 12));
        res = res.replace(/h/g, (hours % 12).toString());
        res = res.replace(/mm/g, leftPadDate(minutes));
        res = res.replace(/m/g, minutes.toString());
        res = res.replace(/ss/g, leftPadDate(seconds));
        res = res.replace(/s/g, seconds.toString());
        res = /MMMM/.test(res)
            ? res.replace(/MMMM/g, fullMonthNames[month])
            : /MMM/.test(res)
                ? res.replace(/MMM/g, shortMonthNames[month])
                : /MM/.test(res)
                    ? res.replace(/MM/g, leftPadDate(month + 1))
                    : /M/.test(res) ? res.replace(/M/g, (month + 1).toString()) : res;
        return res;
    }
    return year + "-" + leftPadDate(month) + "-" + leftPadDate(day) + "T" + leftPadDate(hours) + ":" + leftPadDate(minutes) + ":" + leftPadDate(seconds);
}

exports.formatDate = formatDate;
